import { Box, useMediaQuery, useTheme } from '@mui/material'
import { MidGard } from './components/MidGard'
import { OathOfPeak } from './components/OathOfPeak'
import { ManasisRefram } from './components/ManasisRefram'
import { WhatsNews } from './components/WhatsNews'
import { FAQ } from './components/FAQ'
import { useHomeIndexConfig } from 'services/module/home'
import { HomeCarousel } from './components/HomeCarousel'
import { useAccountModal, useModalOpen } from 'state/application/hooks'
import { ApplicationModal } from 'state/application/reducer'
import { useMemo } from 'react'

export default function Home() {
  const indexConfig = useHomeIndexConfig()
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.down('md'))

  const mobileMenuModal = useModalOpen(ApplicationModal.MOBILE_MENU)
  const mobileUserMenuModal = useModalOpen(ApplicationModal.MOBILE_USER_MENU)
  const accountModal = useAccountModal()

  const showVideo = useMemo(() => {
    return (mobileMenuModal || mobileUserMenuModal || accountModal !== 'close') && md
  }, [mobileMenuModal, mobileUserMenuModal, accountModal, md])
  return (
    <>
      <Box sx={{ background: theme.colors.black }}>
        <HomeCarousel></HomeCarousel>
        <MidGard
          id={indexConfig && indexConfig.gameIds[0] ? indexConfig.gameIds[0] : ''}
          videoUrl={indexConfig && indexConfig.gameIds[0] ? indexConfig.videoUrls[0] : ''}
          poster={indexConfig ? indexConfig.videoUrls[3] : ''}
          showVideo={showVideo}
        ></MidGard>
        <OathOfPeak
          id={indexConfig && indexConfig.gameIds[1] ? indexConfig.gameIds[1] : ''}
          videoUrl={indexConfig && indexConfig.gameIds[1] ? indexConfig.videoUrls[1] : ''}
          poster={indexConfig ? indexConfig.videoUrls[4] : ''}
          showVideo={showVideo}
        ></OathOfPeak>
        <ManasisRefram
          id={indexConfig && indexConfig.gameIds[2] ? indexConfig.gameIds[2] : ''}
          videoUrl={indexConfig && indexConfig.gameIds[2] ? indexConfig.videoUrls[2] : ''}
          poster={indexConfig ? indexConfig.videoUrls[5] : ''}
          showVideo={showVideo}
        ></ManasisRefram>
        <WhatsNews></WhatsNews>
        <FAQ></FAQ>
      </Box>
    </>
  )
}
